import {
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBRadio,
  MDBSelect,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLoader from "../../../views/popups/PopupLoader";
import AddHolidays from "../../../views/popups/locations/AddHolidays";
import DeleteHoliday from "../../../views/popups/locations/DeleteHolidays";
import LocWeeklySchedule from "./LocWeeklySchedule";
import { Tooltip } from "react-tooltip";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import { getMisc } from "../../../apiclients/streamsapi_bridge";

function LocSchedule({
  register,
  setValue,
  getValues,
  unregister,
  holidaysList,
  locationid,
  setSuccessMessage,
  lunaid,
  allLocations,
  watch,
  reset,
  setenableHolidays,
  reqFromCallFlow,
  setreqFromCallFlow,
  errors,
  clearErrors,
  timezone

}) {
  const { t, i18n } = useTranslation();
  const [selectedOption2, setSelectedOption2] = useState("option1");
  const [AddHoliday, setAddHoliday] = useState(false);
  const toggleShow18 = () => setAddHoliday(!AddHoliday);
  const [deleteHoliday, setDeleteHoliday] = useState(false);
  const toggleDelete = () => setDeleteHoliday(!deleteHoliday);
  const [holidays, setHolidays] = useState([]);
  const [addEditHolidays, setAddEditHolidays] = useState(false);
  const [modifiedObj, setModifiedObj] = useState({});
  const [editObj, setEditObj] = useState({});
  const [allowEdit, setAllowEdit] = useState(false);
  const [deleteHolidayId, setDeleteHolidayId] = useState("");
  const addHolidayRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  function handleClick() {
    addHolidayRef.current.click();
  }
  const weeklyFields = [
    {
      fieldLabel: t("sunday"),
      fieldValue: "sun",
    },
    {
      fieldLabel: t("monday"),
      fieldValue: "mon",
    },
    {
      fieldLabel: t("tuesday"),
      fieldValue: "tue",
    },
    {
      fieldLabel: t("wednesday"),
      fieldValue: "wed",
    },
    {
      fieldLabel: t("thursday"),
      fieldValue: "thu",
    },
    {
      fieldLabel: t("friday"),
      fieldValue: "fri",
    },
    {
      fieldLabel: t("saturday"),
      fieldValue: "sat",
    },
  ];
  useEffect(() => {
    if (holidaysList && holidaysList.length > 0) {
      setHolidays(holidaysList);
    }
  }, [holidaysList]);



  useEffect(() => {
    if (addEditHolidays && modifiedObj && Object.keys(modifiedObj).length > 0) {
      if (modifiedObj.isEdited) {
        delete modifiedObj.isEdited;
        // Filter out the existing object from whiteList and add the updated existObj
        const index = holidays.findIndex(
          (item) => item.holiday_id == modifiedObj.holiday_id
        );
        if (index != -1) {
          holidays.splice(index, 1, modifiedObj);
          if (setenableHolidays) {
            if (holidays.length > 0) {
              setenableHolidays(true);
            } else {
              setenableHolidays(false);
            }
          }
        }
      } else {
        const newHolidays = [...holidays, modifiedObj];
        setHolidays(newHolidays);
        if (setenableHolidays) {
          if (newHolidays.length > 0) {
            setenableHolidays(true);
          } else {
            setenableHolidays(false);
          }
        }
      }
    }
    if (addEditHolidays && deleteHolidayId != "") {
      const update = holidays.filter(
        (item) => item.holiday_id != deleteHolidayId
      );
      setHolidays(update);
      if (setenableHolidays) {
        if (update.length > 0) {
          setenableHolidays(true);
        } else {
          setenableHolidays(false);
        }
      }
      setDeleteHolidayId("");
    }
    if (reqFromCallFlow) {
      if (window.opener && window.opener.receiveMessageFromChild) {
        window.opener.receiveMessageFromChild(1); // Send a message to the parent
      }
      setreqFromCallFlow(false);
      window.close();
    }
    setAddEditHolidays(false);
  }, [addEditHolidays]);

  let proccessdRows = [];

  holidays &&
    holidays.map((holiday) => {
      proccessdRows.push({
        holidayDetail: holiday,
        name: holiday.name,
        position: `From : ${holiday.from} To : ${holiday.to}`,
        action: (
          <>
            <div className="d-flex align-items-center ms-2">
              <div
                className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
                onClick={(e) => handleDelete(e, holiday.holiday_id)}
              >
                <MDBIcon
                  fas
                  icon="times"
                  color="primary"
                  className="mx-2 fs-5"
                />
              </div>
            </div>
            {/* <MDBIcon
              fas
              icon="times"
              color="primary"
              className="ms-3 cursor-pointer"
              onClick={(e) => handleDelete(e, holiday.holiday_id)}
            /> */}
          </>
        ),
      });
    });
  const basicData = {
    columns: [
      { label: "Name", field: "name", sort: true },
      { label: "Date and Time Range", field: "position" },
      { label: "Remove", field: "action", sort: false },
    ],
    rows: proccessdRows,
    pagination: false,
  };

  function handleDelete(e, id) {
    e.preventDefault();
    e.stopPropagation();
    setDeleteHolidayId(id);
    toggleDelete();
  }
  const handleScheduleDays = (day) => {
    const isChecked = getValues(`schedule.weekly_schedule.${day}.selected`);
    setValue(`schedule.weekly_schedule.${day}.selected`, !isChecked, {
      shouldDirty: true,
    });
  };
  function EditHoliday(event) {
    const holiday = event.holidayDetail;
    setEditObj({
      id: holiday.holiday_id,
      name: holiday.name,
      from: holiday.from,
      to: holiday.to,
    });
    setAllowEdit(true);

    toggleShow18();
  }

  async function fetchScheduleDetails(locid) {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      {
        misc: ["luna_loc"],
        lunaid: lunaid,
        loc_id: parseInt(locid),
      }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      // navigate("/");
    }

    const lunaDetails = tdata?.misc ?? {};

    console.log(
      "locations change list :::::::::::::: " + JSON.stringify(tdata)
    );

    setHolidays(lunaDetails?.luna_loc?.holidays ?? []);

    reset((prev) => ({
      ...prev,
      schedule: {
        all_time: lunaDetails?.luna_loc?.schedule?.all_time ?? false,
        weekly_schedule: {
          sun: {
            selected:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.sun?.selected ??
              false,
            from_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.sun
                ?.from_time ?? "",
            to_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.sun?.to_time ??
              "",
            twenty_four:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.sun
                ?.twenty_four ?? false,
          },
          mon: {
            selected:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.mon?.selected ??
              false,
            from_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.mon
                ?.from_time ?? "",
            to_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.mon?.to_time ??
              "",
            twenty_four:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.mon
                ?.twenty_four ?? false,
          },
          tue: {
            selected:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.tue?.selected ??
              false,
            from_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.tue
                ?.from_time ?? "",
            to_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.tue?.to_time ??
              "",
            twenty_four:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.tue
                ?.twenty_four ?? false,
          },
          wed: {
            selected:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.wed?.selected ??
              false,
            from_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.wed
                ?.from_time ?? "",
            to_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.wed?.to_time ??
              "",
            twenty_four:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.wed
                ?.twenty_four ?? false,
          },
          thu: {
            selected:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.thu?.selected ??
              false,
            from_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.thu
                ?.from_time ?? "",
            to_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.thu?.to_time ??
              "",
            twenty_four:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.thu
                ?.twenty_four ?? false,
          },
          fri: {
            selected:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.fri?.selected ??
              false,
            from_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.fri
                ?.from_time ?? "",
            to_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.fri?.to_time ??
              "",
            twenty_four:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.fri
                ?.twenty_four ?? false,
          },
          sat: {
            selected:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.sat?.selected ??
              false,
            from_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.sat
                ?.from_time ?? "",
            to_time:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.sat?.to_time ??
              "",
            twenty_four:
              lunaDetails?.luna_loc?.schedule?.weekly_schedule?.sat
                ?.twenty_four ?? false,
          },
        },
      },
    }));
    setValue("schedule.sch_loc_id", locid, {
      shouldDirty: true,
    });
  }


  useEffect(() => {
    const patchTitles = () => {
      const tds = document.querySelectorAll('table td');
      tds.forEach(td => {
        const trimmed = td.textContent.trim();
        if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
          td.setAttribute('title', trimmed);
        }
      });
    };

    patchTitles();

    const table = document.querySelector('.LocDetails-Table');

    if (!table) return;

    const observer = new MutationObserver(() => {
      patchTitles();
    });

    observer.observe(table, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);


  return (
    <>
      <div id="weeklyschedule">
        <div className="general-settings">{t("Weekly Schedule")}</div>
        <div className="d-flex align-items-center">
          <MDBRadio
            name="inlineRadio"
            id="inlineRadio1"
            value={true}
            label="24/7"
            inline
            checked={getValues("schedule.all_time")}
            onChange={() =>
              setValue("schedule.all_time", true, { shouldDirty: true })
            }
          />
          <MDBRadio
            name="inlineRadio"
            id="inlineRadio2"
            value={false}
            label="Weekly Schedule"
            inline
            checked={!getValues("schedule.all_time")}
            onChange={() =>
              setValue("schedule.all_time", false, { shouldDirty: true })
            }
          />
          <div className="ms-3 d-flex">
            {timezone && <p className="mb-0"><strong>Timezone:</strong> {timezone}</p>}
          </div>

          {allLocations && allLocations.length > 0 && lunaid && (
            <MDBSelect
              className="w-30"
              name="San Jose"
              search
              data={allLocations}
              value={parseInt(watch("schedule.sch_loc_id"))}
              onChange={(e) => {
                if (
                  e &&
                  e.value &&
                  parseInt(watch("schedule.sch_loc_id")) !== parseInt(e.value)
                ) {
                  fetchScheduleDetails(parseInt(e.value));
                }
              }}
            />
          )}
        </div>

        {!getValues("schedule.all_time") && (
          <>
            <div className="row">
              <div className=" w-100">
                {weeklyFields.map((item) => (
                  <LocWeeklySchedule
                    register={register}
                    getValues={getValues}
                    setValue={setValue}
                    unregister={unregister}
                    checkedSelected={`schedule.weekly_schedule.${item.fieldValue}.selected`}
                    twentyFourFlag={`schedule.weekly_schedule.${item.fieldValue}.twenty_four`}
                    fromTime={`schedule.weekly_schedule.${item.fieldValue}.from_time`}
                    toTime={`schedule.weekly_schedule.${item.fieldValue}.to_time`}
                    fieldLabel={item.fieldLabel}
                    errors={errors}
                    clearErrors={clearErrors}
                    watch={watch}
                  />
                ))}
              </div>
            </div>
          </>
        )}
        <div className="d-flex justify-content-between border-0 mt-3">
          <h6 className="my-2">{t("Holidays")}</h6>
          <MDBBtn
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setEditObj({});
              setAllowEdit(false);
              toggleShow18();
            }}
          >
            <MDBIcon fas icon="plus" color="white" /> Add Holiday
          </MDBBtn>
        </div>
        <div className="addHolidayLoc">
          <MDBDatatable
            onRowClick={(event) => {
              EditHoliday(event);
            }}
            data={basicData}
            pagination={false}
            sortField="Name"
            className="actioncolumn LocDetails-Table"
          />
        </div>
      </div>

      {deleteHoliday && (
        <PopupLoaderNew
          size="md"
          className="small-popup"
          title={t("Remove Holiday")}
          content={
            <DeleteHoliday
              onClose={toggleDelete}
              locationid={locationid}
              setSuccessMessage={setSuccessMessage}
              addEditFlag={setAddEditHolidays}
              deleteHolidayId={deleteHolidayId}
              ref={addHolidayRef}
              setIsloading={setisLoading}
              lunaid={lunaid}
            />
          }
          onShow={setDeleteHoliday}
          onClose={toggleDelete}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}

      {AddHoliday && (
        <PopupLoaderNew
          size="md"
          className="small-popup"
          title={allowEdit ? "Edit Holiday" : t("addHoliday")}
          content={
            <AddHolidays
              onClose={toggleShow18}
              locationid={locationid}
              setSuccessMessage={setSuccessMessage}
              addEditFlag={setAddEditHolidays}
              modifyObj={setModifiedObj}
              isEdit={allowEdit}
              editObj={editObj}
              ref={addHolidayRef}
              setIsloading={setisLoading}
              lunaid={lunaid}
            />
          }
          onShow={setAddHoliday}
          onClose={toggleShow18}
          onSave={handleClick}
          isloading={isLoading}
          flag={allowEdit ? 2 : 1}
        />
      )}

      <Tooltip
        anchorSelect=".deleteToolTip"
        place="top"
        className="exampleTooltip"
      >
        Remove
      </Tooltip>
    </>
  );
}

export default LocSchedule;
